module.exports = __webpack_public_path__ + "img/gn.5ab79ace.svg";